import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  providers: [AngularFireDatabase],
})
export class UserListComponent implements OnInit {
  users: Observable<any[]>;

  constructor(private db : AngularFireDatabase) { }

  ngOnInit() {
    let itemsRef = this.db.list('profiles', ref => ref.limitToLast(6));

    this.users = itemsRef.snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.key, ...c.payload.val() }));
    });
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/users/user-list/user-list.component.ts